/**
 * 我的线索
 */
<template>
  <div style="margin-top: 20px;">
      <!-- 左边导航 -->
      <div style="margin-bottom: 12px;font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
        <div v-if="myClueAuth" id="myClueAuth" class="mouse" :class="{'selected':myClueAuthCh}" @click="clickLabel('myClue')">我的线索</div>
        <!-- <div v-if="myClueAuth&&clueManageAuth" style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div> -->
        <div v-if="clueManageAuth" id="clueManageAuth" class="mouse" :class="{'selected':clueManageAuthCh}" @click="clickLabel('clueManage')">线索管理</div>
      </div>
      <!-- 右侧按钮 -->
      <div style="float: right;display: flex;">
        <el-button size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
        <el-button v-if="addClueAuth" size="small" icon="el-icon-plus" class="clue-btn" @click="handleAdd">添加线索</el-button>
        <el-button v-if="clueManageAuthCh" size="small" icon="el-icon-bottom" class="clue-btn" @click="exportClueBtn">下载线索</el-button>
        <el-button v-if="clueManageAuthCh" size="small" icon="el-icon-delete" class="clue-btn" @click="delClueCheck">删除</el-button>
        <!-- <el-input v-if="searchClueAuth" v-model="formInline.search" placeholder="请输入需要查询的条件" clearable class="clue-search">
          <el-button slot="append" icon="el-icon-search" class="clue-search-btn" @click="search"></el-button>
        </el-input> -->
      </div>
    <!--我的线索列表-->
    <div v-if="myClueAuthCh" >
      <el-table size="small" :data="myClueData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="name" align="center" label="称呼" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="查看线索详情" @click="handleClueInfo(scope.$index, scope.row)">{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="company" align="center" label="学校/单位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="identity" align="center" label="职位/岗位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="所属商务" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="source" align="center" label="线索来源" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="录入时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="60">
          <template slot-scope="scope">
            <el-button size="mini" @click="delMyClue(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 线索管理列表 -->
    <el-table v-if="clueManageAuthCh" size="small" :data="clueManageData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
    <el-table-column align="center" type="selection" width="40" fixed="left">
    </el-table-column>
    <el-table-column align="center" type="index" label="序号" width="60" fixed="left">
    </el-table-column>
    <el-table-column prop="name" align="center" label="称呼" show-overflow-tooltip fixed="left">
    </el-table-column>
    <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
      <template slot-scope="scope">
        <span style="color: #407AA8;cursor: pointer;" title="查看线索详情" @click="handleClueManageInfo(scope.$index, scope.row)">{{ scope.row.mobile }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="company" align="center" label="学校/单位" show-overflow-tooltip>
    </el-table-column>
    <el-table-column prop="identity" align="center" label="职位/岗位" show-overflow-tooltip>
    </el-table-column>
    <el-table-column prop="admin_name" align="center" label="所属商务" show-overflow-tooltip>
    </el-table-column>
    <el-table-column prop="source" align="center" label="线索来源" show-overflow-tooltip>
    </el-table-column>
    <el-table-column prop="add_time" align="center" label="录入时间" show-overflow-tooltip>
    </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 线索添加 -->
    <div v-if="addFormVisible" class="clueInfo">
      <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="addFormVisible" height="515px" width="850px" style="text-align: center;">
          <el-form :model="addClueForm" :rules="addClueFormRule" ref="addClueForm">
            <!-- <el-form-item label="联系人姓名" prop="name">
              <el-input size="small" v-model="addClueForm.name" auto-complete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="mobile">
              <el-input size="small" v-model="addClueForm.mobile" auto-complete="off" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-no-more-click size="mini" style="width: 100%;background-color: #00C8DF;color: #FFFFFF;" @click="addClue('addClueForm')">确定</el-button>
            </el-form-item> -->
            <el-descriptions class="margin-top" :column="2" :size="size" border>
              <el-descriptions-item>
                <template slot="label">
                  联系人姓名
                </template>
                <el-form-item prop="name">
                  <el-input size="small" v-model.trim="addClueForm.name" auto-complete="off" clearable placeholder="例:房XX" style="margin-top: 20px;"></el-input>
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  联系人电话
                </template>
                <el-form-item prop="mobile">
                  <el-input size="small" v-model.trim="addClueForm.mobile" auto-complete="off" placeholder="例:130****" style="margin-top: 20px;">
                    <el-button  style="padding-right: 10px;" slot="suffix" type="text" @click="searchRepeatMobile">查重</el-button>
                  </el-input>
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  学校/单位
                </template>
                <el-form-item prop="company">
                  <el-input size="small" v-model.trim="addClueForm.company" auto-complete="off" clearable placeholder="例:西南石油大学-材料院" style="margin-top: 20px;"></el-input>
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  职位/岗位
                </template>
                <el-form-item prop="identity">
                  <el-input size="small" v-model.trim="addClueForm.identity" auto-complete="off" clearable placeholder="例:副教授" style="margin-top: 20px;"></el-input>
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  备注
                </template>
                <el-form-item prop="problem">
                  <el-input size="small" type="textarea" v-model.trim="addClueForm.problem" auto-complete="off" clearable placeholder="例:咨询发明预审" style="margin-top: 20px;"></el-input>
                </el-form-item>
              </el-descriptions-item>
            </el-descriptions>
            <el-form-item style="margin-top: 10px;">
              <el-button size="mini" @click="closeAddClue()" style="float: right;margin-left: 10px;">关闭</el-button>

              <el-button v-no-more-click size="mini" type="primary" @click="addClue('addClueForm')" style="float: right;">确定</el-button>
            </el-form-item>
          </el-form>
      </el-dialog>
    </div>

    <div class="rightDrawer" @click="handleDrawerOpen">
      《《
    </div>
    <el-drawer 
    :visible.sync="drawer" 
    :direction="direction" 
    :before-close="handleDrawerClose" 
    size="360px" 
    title="条件查询" 
    :show-close="false"
    :wrapperClosable="true"
    class="searchDrawer"
    >
      <div style="margin-left: 20px;">
          <el-form :inline="true" :model="formInline">
            <el-form-item label="模糊查询" style="width: 320px;">
              <el-input size="small" v-model.trim="formInline.search" placeholder="请输入关键词" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" style="width: 320px;">
              <el-input size="small" v-model.trim="formInline.mobile" placeholder="请输入联系方式" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="所属商务" v-if="clueManageAuthCh" style="width: 320px;">
              <el-select size="small" v-model.trim="formInline.admin_id" placeholder="请选择" filterable clearable style="width: 250px;">
                <el-option v-for="type in searchSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录入时间" class="clueDatePicker" style="width: 320px;">
               <el-date-picker
                  v-model="searchDateValue"
                  @change="getSearchDate"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  unlink-panels
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00',  '23:59:59']"
                  style="width: 250px;">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="searchClue">查询</el-button>
              <el-button type="warning" size="small" @click="resetSearch">重置</el-button>
              <el-button type="danger" size="small" @click="handleDrawerClose">关闭</el-button>
            </el-form-item>
          </el-form>
      </div>
    </el-drawer>

     <!-- 线索查重页面 -->
     <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="repeatVisible" width="400px" style="text-align: center;">
        <span style="color: #FF0000;float: left;margin-top: -30px;font-size: 12px;">注：最多显示20个查重记录</span>
        <el-table size="small" :data="repeatClue" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;height: 300px;overflow-y: auto;">
          <el-table-column prop="mobile" align="center" label="电话" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="admin_name" align="center" label="所属商务" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="source" align="center" label="来源" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 我的线索详情页面 -->
      <div v-if="myClueInfoVisible" class="clueInfo">
        <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="myClueInfoVisible" height="515px" width="850px" style="text-align: center;">
          <!-- 基本信息 -->
          <div>
            <!-- 久在樊笼里，复得返自然 -->
            <!-- <el-label>手机号：18227357021</el-label> -->
            <el-descriptions class="margin-top" :column="3" :size="size" border>
              <el-descriptions-item>
                <template slot="label">
                  手机号
                </template>
                {{ clueInfo.mobile }}
                <span class="updateMobile" title="修改手机号" @click="handleMobile()">修改</span>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  称谓
                </template>
                {{ clueInfo.name }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  归属地
                </template>
                {{ clueInfo.mobile_place }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  院校/单位
                </template>
                {{ clueInfo.company }}
              </el-descriptions-item>
               <el-descriptions-item>
                <template slot="label">
                  职位/岗位
                </template>
                {{ clueInfo.identity }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  来源
                </template>
                  {{ clueInfo.source }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  添加时间
                </template>
                  {{ clueInfo.add_time }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  备注
                </template>
                  {{ clueInfo.problem }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-divider></el-divider>
          <div class="clueInfoDialog">
            <el-row>
              <!-- 线索编辑 -->
              <el-col :span="12" style="height: 310px;border: 1px solid #DCDFE6;">
                <div style="padding-right: 20px;padding-top: 10px;">
                  <span class="infoTitle">线索编辑</span>
                  <el-form label-width="120px" :model="editClueForm" :rules="editClueFormRule" ref="editClueForm" style="margin-top: 10px;">
                    <el-form-item label="称谓/姓名" prop="real_name">
                      <el-input size="small" v-model.trim="editClueForm.real_name" auto-complete="off" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="院校/单位" prop="company">
                      <el-input size="small" v-model.trim="editClueForm.company" auto-complete="off" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="职位/岗位" prop="identity">
                      <el-input size="small" v-model.trim="editClueForm.identity" auto-complete="off" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="备注/咨询" prop="problem">
                      <el-input size="small" v-model.trim="editClueForm.problem" auto-complete="off" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button v-no-more-click type="primary" size="small" @click="editClueBtn('editClueForm')" style="float: right;margin-top: 10px;">提交</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </el-col>
              <!-- 跟进记录 -->
              <el-col :span="12" style="height: 310px;border: 1px solid #DCDFE6;">
                  <div style="padding-right: 20px;padding-top: 10px;">
                    <span class="infoTitle">跟进记录</span>
                    <div style="display: flex;">
                      <div style="margin-top: 10px;width: 60%;overflow-y: auto;height: 260px;">
                      <el-timeline>
                          <el-timeline-item 
                          v-for="(contactItem,index) in contactData"
                          :key="index"
                          :timestamp="contactItem.add_time">
                            {{ contactItem.contact_desc}}
                          </el-timeline-item>
                      </el-timeline>
                      </div>
                      <div style="margin-left: 10px;">
                        <el-form :model="addClueContactForm" :rules="addClueContactFormRule" ref="addClueContactForm"> 
                          <el-form-item label="添加记录" prop="contact">
                            <el-input type="textarea" v-model="addClueContactForm.contact"></el-input>
                          </el-form-item>
                          <el-form-item>
                            <el-button type="primary" size="small" @click="addClueContactBtn('addClueContactForm')" style="float: right;margin-top: 10px;">提交</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
              </el-col>
            </el-row>
          </div>
        </el-dialog>
      </div>

      <!-- 线索管理详情页面 -->
      <div v-if="clueManageInfoVisible" class="clueInfo">
        <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="clueManageInfoVisible" height="515px" width="850px" style="text-align: center;">
          <el-row>
            <el-col :span="16" style="border: 1px solid #DCDFE6;">
              <div>
                <el-descriptions class="margin-top" :column="2" :size="size" border>
                <el-descriptions-item>
                  <template slot="label">
                    手机号
                  </template>
                  {{ clueInfo.mobile }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    称谓
                  </template>
                  {{ clueInfo.name }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    归属地
                  </template>
                  {{ clueInfo.mobile_place }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    院校/单位
                  </template>
                  {{ clueInfo.company }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    职位/岗位
                  </template>
                  {{ clueInfo.identity }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    来源
                  </template>
                    {{ clueInfo.source }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    所属商务
                  </template>
                  {{ clueInfo.admin_name }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    添加时间
                  </template>
                    {{ clueInfo.add_time }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    备注
                  </template>
                    {{ clueInfo.problem }}
                </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-col>
            <el-col :span="8" style="border: 1px solid #DCDFE6;">
              <span style="font-weight: 400;font-size: 16px;color: #333333;">跟进记录</span>
              <div style="margin-top: 10px;height: 400px;overflow-y: auto;">
                <el-timeline>
                    <el-timeline-item 
                    v-for="(contactItem,index) in contactData"
                    :key="index"
                    :timestamp="contactItem.add_time">
                      {{ contactItem.contact_desc}}
                    </el-timeline-item>
                </el-timeline>
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>

       <!-- 线索手机号修改页面 -->
     <el-dialog v-dialogDrag :close-on-click-modal="false" title="手机号修改" :visible.sync="mobileUpdateVisible" width="400px" style="text-align: center;">
        <el-form label-width="120px" :model="mobileForm">
          <el-form-item label="手机号号" prop="mobile">
                <el-input size="small" v-model="mobileForm.mobile" auto-complete="off" placeholder="请填写手机号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="submitMobileForm()">确定</el-button>
            <el-button size="mini" @click='closeDialogMobile()'>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </div>
</template>

<script>

import { 
  getMyClue,
  addClue,
  getManageClue,
  getAuthAdmin,
  searchRepeatMobile,
  exportClue,
  delCheckClue,
  editClue,
  getMyClueInfo,
  addClueContact,
  delMyClue,
  updateClueMobile } from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false, //控制添加页面显示与隐藏
      repeatVisible: false, //控制线索查重页面显示与隐藏
      myClueInfoVisible: false, //控制我的线索详情页面显示与隐藏
      clueManageInfoVisible: false, //控制线索管理详情页面显示与隐藏
      mobileUpdateVisible: false, //控制线索手机号修改页面显示与隐藏
      title: '预览',
      editForm: {
        id: '',
        name: '',
        mobile: ''
      },
      addClueForm: {
        name: '',
        mobile: '',
        company: '',
        identity: '',
        problem: ''
      },
      editClueForm: {
        id: '',
        real_name: '',
        company: '',
        identity: '',
        problem: '',
      },
      addClueContactForm: {
        id: '',
        contact: ''
      },
      // 筛选框
      searchDateValue: '',
      size: '',

      // 按钮权限 --- 开始 ---
      // 我的线索按钮
      myClueAuth: false,
      clueManageAuth: false,
      myClueAuthCh: false,
      clueManageAuthCh: false,
      addClueAuth: true,
      searchClueAuth: true,
      // 线索权限按钮
      clueAuth: [],
      // 按钮权限 --- 结束 ---

      // 搜索框开始
      drawer: false,
      direction: 'rtl',
      // 搜索框结束

      reverse: true,

       // 商务列表(查询)
      searchSeller: [],

      formInline: {
        page: 1,
        ps: 15,
        search: '',
        mobile: '',
        admin_id: '',
        startDate: '',
        endDate: ''
      },
      mobileForm: {
        id: '',
        mobile: ''
      },
      multipleSelection: [], //列表勾选框值
      userparm: [], //搜索权限
      listData: [], //用户数据
      myClueData: [], //我的线索数据
      clueManageData: [], //线索管理数据
      repeatClue: [], //线索查重数据
      clueInfo: [], //线索详情数据
      contactData: [], //线索跟踪记录数据
      // 参数校验
      addClueFormRule: {
        name:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile:[{ required: true, message: '请输入手机号', trigger: 'blur' }],
        company:[{ required: true, message: '请输入院校/单位', trigger: 'blur' }],
        identity:[{ required: true, message: '请输入职位/岗位', trigger: 'blur' }],
      },
      editClueFormRule: {
        real_name:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
        company:[{ required: true, message: '请输入院校/单位', trigger: 'blur' }],
        identity:[{ required: true, message: '请输入职位/岗位', trigger: 'blur' }],
        problem:[{ required: true, message: '请输入备注/咨询', trigger: 'blur' }],
      },
      addClueContactFormRule: {
        contact:[{ required: true, message: '请输入跟进记录详情', trigger: 'blur' }],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
    if(btnAuth.includes("myClueAuth")){
      this.myClueAuth = true
      this.myClueAuthCh = true
      this.getMyCluePageList()
    }
    if(btnAuth.includes("clueManageAuth")){
      this.clueManageAuth = true
      if(!this.myClueAuth){
        this.clueManageAuthCh = true
      }}
    // this.getdata(this.formInline)
    // this.myClueAuthCh = true
    this.getSellerSelectData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 23,
        data: [
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '蒋老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          },
          {
            origin: '专利卫士',
            name: '廖老师',
            mobile: '13045699696',
            seller: '龙五',
            add_time: '2023-08-11 17:45'
          }
        ]
      }
      this.loading = false
      this.listData = res.data
      this.pageparm.currentPage = this.formInline.page
      this.pageparm.pageSize = this.formInline.limit
      this.pageparm.total = res.count
    },
    // 获取我的线索
    getMyCluePageList() {
      this.loading = true
      getMyClue(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.myClueData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
        }
      })
    },
    // 获取线索管理
    getClueManageData() {
      this.loading = true
      getManageClue(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.clueManageData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
        }
      })
    },
    // 监听日期选择器值的变化
    getSearchDate() {
      console.log(this.searchDateValue)
      let dateValue = this.searchDateValue
      if(dateValue){
        this.formInline.startDate = dateValue[0]
        this.formInline.endDate = dateValue[1]
      }else{
        this.formInline.startDate = ''
        this.formInline.endDate = ''
      }
    },
       // 查询商务列表(搜索栏下拉框)
    getSellerSelectData() {
      getAuthAdmin()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.searchSeller = res.data
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      if(this.myClueAuthCh){
        this.getMyCluePageList()
      }else if(this.clueManageAuthCh){
        this.getClueManageData()
      }
      // this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      if(row){
        this.editFormVisible = true
        this.editForm = row
      }else{
        this.editFormVisible = true
        this.editTitle = '新的线索'
      }
      
    },
    // 显示线索添加界面
    handleAdd() {
      this.title = '添加线索'
      this.addClueForm.name = ''
      this.addClueForm.mobile = ''
      this.addClueForm.company = ''
      this.addClueForm.identity = ''
      this.addClueForm.problem = ''
      this.addFormVisible = true
    },
    // 添加线索(提交)
    addClue(formName) {
      this.$refs[formName].validate(valid => {
        if(valid){
          addClue(this.addClueForm)
            .then(res=>{
              res = checkLogin(res)
              if(res.code == 200){
                this.$message({
                    type: 'success',
                    message: res.msg
                })
                this.addFormVisible = false
                this.getMyCluePageList() 
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                }) 
              }
            })
        }
      })
      
    },
    // 下载线索（导出）
    exportClueBtn() {
      this.$confirm('确定导出所有满足条件的线索吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(()=>{
        console.log(this.formInline)
        exportClue(this.formInline)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: '导出成功!'
            }) 
            window.location.href = res.data.url
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
          }
        })
      })
       .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 开启搜索框
    handleDrawerOpen() {
      let that = this
      // getSearchSeller()
      // .then(res=>{
      //   if(res.code == 200){
      //     that.searchSeller = res.data
      //   }else{
      //     that.searchSeller = []
      //   }
      // })
      this.drawer = true
    },
    // 关闭搜索框
    handleDrawerClose() {
      this.drawer = false
    },
    // 重置搜索框
    resetSearch() {
      this.formInline.admin_id = ''
      this.formInline.search = ''
      this.formInline.startDate = ''
      this.formInline.endDate = ''
      this.formInline.mobile = ''
      this.formInline.page = 1
      this.formInline.ps = 15
      this.searchDateValue = ''
      if(this.myClueAuthCh){
        this.getMyCluePageList()
      }else if(this.clueManageAuthCh){
        this.getClueManageData()
      }
    },
    // 搜索线索
    searchClue() {
      this.formInline.page = 1
      if(this.myClueAuthCh){
        this.getMyCluePageList()
      }else if(this.clueManageAuthCh){
        this.getClueManageData()
      }
      // console.log(123)
    },
    // 顶部选项卡切换
    clickLabel(labelName) {
      if(labelName == 'myClue'){
        this.clueManageAuthCh = false
        this.myClueAuthCh = true
        this.formInline.page = 1
        this.formInline.admin_id = '',
        this.formInline.search = '',
        this.formInline.mobile = '',
        this.formInline.startDate = '',
        this.formInline.endDate = '',
        this.searchDateValue = ''
        this.getMyCluePageList()
      }else if(labelName == 'clueManage'){
        this.myClueAuthCh = false
        this.clueManageAuthCh = true
        this.formInline.page = 1
        this.formInline.admin_id = '',
        this.formInline.search = '',
        this.formInline.mobile = '',
        this.formInline.startDate = '',
        this.formInline.endDate = '',
        this.searchDateValue = ''
        this.getClueManageData()
      }else{
        this.$message({
          type: 'info',
          message: '系统异常,请稍后再试!'
        })
      }
    },
    // 选中我的线索
    clickMyClue() {
      this.clueManageAuthCh = false
      this.myClueAuthCh = true
      this.getMyCluePageList()
    },
    // 选中线索管理
    clickClueManage() {
      this.myClueAuthCh = false
      this.clueManageAuthCh = true
      this.getClueManageData()
    },
    // 删除线索(勾选中)
    delClueCheck() {
      let checkIds = this.multipleSelection
      if(checkIds.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选的数据!'
        })
        return false
      }
      this.$confirm('确定删除勾选中的线索吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let ids = []
        checkIds.forEach((item,index)=>{
          ids.push(item.id)
        })
        let param = JSON.stringify(ids)
        delCheckClue({ids: param})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getClueManageData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除我的线索
    delMyClue(idnex,row) {
      this.$confirm('确定删除勾选中的线索吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let param = {
          id: row.id
        }
        delMyClue(param)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getMyCluePageList()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })

      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 刷新数据
    refreshData() {
      console.log('刷新数据!')
      // this.formInline.page = 1
      if(this.myClueAuthCh){
          this.getMyCluePageList()
      }else if(this.clueManageAuthCh){
          this.getClueManageData()
      }
    },
    // 显示手机号修改页面
    handleMobile() {
      let id = this.clueInfo.id
      let mobile = this.clueInfo.mobile
      if(id.length <= 0 || mobile.length <= 0){
        this.$message({
            type: 'info',
            message: '系统错误,请稍后再试!'
          })
          return false
      }
      this.mobileForm.id = id
      this.mobileForm.mobile = mobile
      this.mobileUpdateVisible= true
    },
    closeAddClue() {
      this.addFormVisible = false
    },
    // 显示线索详情
    handleClueInfo(index, row) {
      // 获取线索详情信息
      getMyClueInfo({id:row.id})
      .then(res=>{
        if(res.code == 200){
          this.clueInfo = res.data.clue
          this.contactData = res.data.contact
          this.editClueForm.id = res.data.clue.id
          this.editClueForm.real_name = res.data.clue.real_name
          this.editClueForm.company = res.data.clue.company
          this.editClueForm.identity = res.data.clue.identity
          this.editClueForm.problem = res.data.clue.problem
          this.addClueContactForm.id = res.data.clue.id
          this.addClueContactForm.contact = ''
          this.title = '线索详情'
          this.myClueInfoVisible = true
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 显示线索管理详情
    handleClueManageInfo(index, row) {
      // 获取线索详情信息
      getMyClueInfo({id:row.id})
      .then(res=>{
        if(res.code == 200){
          this.clueInfo = res.data.clue
          this.clueInfo.admin_name = row.admin_name
          this.contactData = res.data.contact
          this.title = '线索详情'
          this.clueManageInfoVisible = true
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 线索手机号查重
    searchRepeatMobile() {
      let mobile = this.addClueForm.mobile
      if(mobile.length <= 0){
        return false
      }
      searchRepeatMobile({mobile: mobile})
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            // console.log(res)
            this.title = '线索查重'
            this.repeatClue = res.data
            this.repeatVisible = true
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      
    },
    // 线索编辑
    editClueBtn(editClueForm) {
      // console.log(this.editClueForm)
      this.$refs[editClueForm].validate(valid => {
        if(valid){
          editClue(this.editClueForm)
          .then(res=>{
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.myClueInfoVisible = false
              this.getMyCluePageList()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
        }else{
          return false
        }
      })
    },
    // 添加线索跟进记录
    addClueContactBtn(addClueContactForm) {
      this.$refs[addClueContactForm].validate(valid => {
        if(valid){
          addClueContact(this.addClueContactForm)
          .then(res=>{
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.myClueInfoVisible = false
              this.getMyCluePageList()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
        }else{
          return false
        }
      })
    },
    // 提交手机号码修改
    submitMobileForm(){
      let param = this.mobileForm
      if(param.mobile.length <= 0){
        this.$message({
          type: 'error',
          message: '手机号不能为空!'
        })
        return false
      }
      updateClueMobile(param)
          .then(res=>{
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.mobileUpdateVisible = false
              this.handleClueInfo(1,param)
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    closeDialogMobile(){
      this.mobileUpdateVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.clue-btn {
  background-color: #333333;
  color: #FFFFFF;
}
.clue-search {
  margin-left: 20px;
  background-color: #E4E4E4;
}
.clue-search-btn {
  background-color: #333333 !important;
  color: #FFFFFF !important;
  font-weight: 700 !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.u-btn {
  display: none;
}
.mouse {
  cursor: pointer;
  color: #D9D9D9;
  margin-right: 18px;
}
.selected {
  color: #333333;
}
.rightDrawer {
  width: 40px;
  height: 100px;
  background-color: #00C8DF;
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  left: auto;
  right: 0;
  top: 40%;
  z-index: 10;
  color: #FFFFFF;
  text-align: center;
  margin-top: auto;
  line-height: 100px;
  cursor: pointer;
}
.searchDrawer {
  height: 80vh;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 20px 0px 0px 20px;
}
.clueDatePicker>>>.el-range-editor.el-input__inner {
  padding: 1px 4px;
}
.clueDatePicker>>>.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 215px;
  height: 34px;
}
.clueInfo>>>.el-dialog__body {
  border-top: 1px solid #C0C4CC !important;
}
.clueInfoDialog>>>.el-form-item {
  margin-bottom: 12px !important;
}
.infoTitle {
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  margin-left: 40px;
}
.updateMobile {
  background-color: #FAFAFA;
  padding: 4px;
  font-size: 12px;
  color: #909399;
  cursor: pointer;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/crm/clue.vue